export type PremiumEligibility =
  | { status: "eligible" }
  | { status: "active"; currentPeriodEnd?: Date };

export type PremiumCredit = {
  creditStatus?: string;
  creditType?: string;
  endDate?: Date;
  startDate?: Date;
};

export function resolvePremiumEligibility(
  credits: PremiumCredit[],
  now = new Date()
): PremiumEligibility {
  const activePremiumCredits = credits
    .filter(credit => credit.creditType === "FAMILYWALL_PREMIUM")
    .filter(credit => credit.creditStatus === "ACTIVE")
    .filter(credit => credit.startDate === undefined || credit.startDate <= now)
    .filter(credit => credit.endDate === undefined || credit.endDate > now);

  if (activePremiumCredits.length === 0) return { status: "eligible" };

  const endDates = activePremiumCredits
    .map(credit => credit.endDate)
    .filter((endDate): endDate is Date => endDate instanceof Date);
  if (endDates.length !== activePremiumCredits.length) return { status: "active" };

  return {
    status: "active",
    currentPeriodEnd: new Date(Math.max(...endDates.map(endDate => endDate.getTime())))
  };
}
